import { styled, Text, spacing, mq } from '@thg-commerce/enterprise-theme'

export const Container = styled.div`
  max-width: ${(props) => props.theme.site.siteWidth};
  display: flex;
  justify-content: flex-start;
  overflow: scroll;
  margin: 0 auto;
  padding: ${spacing(1)} ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(2)} ${spacing(4)};
    overflow: hidden;
    justify-content: space-evenly;
  }
`

export const TextContainer = styled.div<{}>`
  ${Text('bodyText', 'default')};
  display: flex;
  flex-direction: row;
  min-width: ${(props) =>
    props.theme.widget.GlobalPropositionBar.textContainer.minWidth};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    min-width: 0;
  }
`
